function Error() {
    return (
      <div className="section__error">
        <div className="error">
        Такой страницы не существует!!!
        <h1>404</h1>
        </div>
      </div>
    );
  }
  
  export default Error;